module.exports = __webpack_public_path__ + "img/blue_160.92353b6e.png";